module.exports = __webpack_public_path__ + "static/Redux-icon-65f65909c83231adb5330d939e60d8b8.png";